{
  "xp": {
    "placement": [100, 70, 50, 35],
    "finish": 20,
    "perCoin": 2,
    "coinCap": 15,
    "perItemUsed": 5,
    "itemCap": 5,
    "perHitLanded": 10,
    "hitCap": 5
  },
  "coins": { "placement": [50, 35, 25, 15], "perCoin": 1 },
  "levels": { "baseXp": 200, "stepXp": 50, "maxLevel": 100 },
  "daily": {
    "count": 3,
    "tasks": [
      {
        "id": "play_3",
        "text": "Play 3 races",
        "metric": "races",
        "target": 3,
        "coins": 60,
        "xp": 50
      },
      {
        "id": "finish_3",
        "text": "Finish 3 races",
        "metric": "finishes",
        "target": 3,
        "coins": 60,
        "xp": 60
      },
      {
        "id": "top2_2",
        "text": "Finish in the top 2 twice",
        "metric": "top2",
        "target": 2,
        "coins": 80,
        "xp": 80
      },
      {
        "id": "win_1",
        "text": "Win a race",
        "metric": "wins",
        "target": 1,
        "coins": 100,
        "xp": 100
      },
      {
        "id": "shards_150",
        "text": "Collect 150 shards",
        "metric": "coins",
        "target": 150,
        "coins": 60,
        "xp": 60
      },
      {
        "id": "items_8",
        "text": "Use 8 items",
        "metric": "itemsUsed",
        "target": 8,
        "coins": 60,
        "xp": 60
      },
      {
        "id": "crates_10",
        "text": "Open 10 item boxes",
        "metric": "crates",
        "target": 10,
        "coins": 60,
        "xp": 60
      },
      {
        "id": "spike_3",
        "text": "Throw 3 Spike Balls",
        "metric": "item:spike_ball",
        "target": 3,
        "coins": 70,
        "xp": 70
      },
      {
        "id": "shield_3",
        "text": "Use 3 Shield Bubbles",
        "metric": "item:shield_bubble",
        "target": 3,
        "coins": 70,
        "xp": 70
      },
      {
        "id": "clean_1",
        "text": "Finish a race without falling",
        "metric": "cleanFinishes",
        "target": 1,
        "coins": 80,
        "xp": 80
      },
      {
        "id": "hits_5",
        "text": "Hit 5 racers",
        "metric": "hits",
        "target": 5,
        "coins": 80,
        "xp": 80
      }
    ]
  }
}
